import { render } from "./RootPage.vue?vue&type=template&id=36736151"
import script from "./RootPage.vue?vue&type=script&lang=js"
export * from "./RootPage.vue?vue&type=script&lang=js"

import "./RootPage.vue?vue&type=style&index=0&id=36736151&lang=css"
script.render = render

export default script